<div class="game" (click)="toggleOverlay()">
  <div class="game__badges" [ngClass]="{mystery: game['mystery']}">
    @switch (true) {
      @case (game['hot'] && !game['new'] && !game['dailyDrops']) {
        <img
          class="game__badges--item"
          src="/assets/img/badges/hot.svg"
          [alt]="seo.metaTitle"
          >
      }
      @case (game['jackpot']) {
        @if (jackpotValue) {
          <div class="game__badges--item jackpot-value">
            <img src="/assets/img/badges/jackpot-crown.svg" [alt]="seo.metaTitle">
            {{jackpotValue}}&nbsp;<span>{{currency}}</span>
          </div>
        } @else {
          <img
            class="game__badges--item"
            src="/assets/img/badges/jackpot.svg"
            [alt]="seo.metaTitle"
            >
        }
      }
      @case (game['bonanzaJackpot'] && !game['jackpot']) {
        <img
          class="game__badges--item"
          [src]="'/assets/img/badges/theme/' + themeService.currentTheme + '/' + 'jackpot.svg'"
          [alt]="seo.metaTitle"
          >
      }
      @case (game['preRelease']) {
        <img
          class="game__badges--item"
          src="/assets/img/badges/exclusive.svg"
          [alt]="seo.metaTitle"
          >
      }
      @case (game['new'] && !game['dailyDrops']) {
        <img
          class="game__badges--item"
          src="/assets/img/badges/new.svg"
          [alt]="seo.metaTitle"
          >
      }
      @case (game['freespins']) {
        <img
          class="game__badges--item"
          src="/assets/img/badges/freespins.svg"
          [alt]="seo.metaTitle"
          >
      }
      @case (game['mystery']) {
        <img
          class="game__badges--item mystery-drop"
          src="/assets/img/badges/mystery-drop.png"
          [alt]="seo.metaTitle"
          >
      }
    }
  </div>
  <div class="game__image">
    <img
      defaultImage
      ClassLoaded
      [alternative]="game?.['altImgSrc']"
      [default]="defaultImageType.GAME"
      [src]="game?.['imgSrc']"
      [alt]="seo.metaTitle"
      class="game__image-main"
      >
  </div>
  <div
    class="game__overlay"
    [ngClass]="{'visible': isToggleOverlay}"
    (click)="openGame(modes.real, $event)"
    >
    <i
      [ngClass]="{'icon-like': !game['favorite'], 'icon-like_filled': game['favorite']}"
      (click)="toggleFavourite(game, $event)"
      class="game__overlay--favourite"
      >
    </i>
    <img
      class="game__overlay--play"
      src="/assets/img/badges/play.png"
      [alt]="seo.metaTitle"
      >
    @if (!user.auth && !game['nodemo']) {
      <div class="game__overlay--line-fun"></div>
    }
    @if (!user.auth && !game['nodemo']) {
      <div
        (click)="openGame(modes.demo, $event)"
        class="game__overlay--fun"
        >
        <span class="text-gradient try-fun">{{'t.try-fun' | translate}}</span>
      </div>
    }
    <a [href]="gameUrl"></a>
  </div>
</div>
@if (isShowGameInfo) {
  <div class="game__info">
    <div class="game__info--title" [title]="game?.name || ''">{{game['name']}}</div>
    <div class="game__info--provider" [title]="game['provider']?.name || ''">{{game['provider']?.name}}</div>
  </div>
}
